import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListWebhookSearchComponent } from './list-webhook-search/list-webhook-search.component';
import { WebhookSearchComponent } from './webhook-search.component';
import { WebhookSearchRoutingModule } from './webhook-search-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SidebarModule } from 'ng-sidebar';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { WebhookSortDirective } from './webhookSort.directive';



@NgModule({
  declarations: [
    ListWebhookSearchComponent, WebhookSearchComponent,WebhookSortDirective
  ],
  imports: [
    CommonModule,
    WebhookSearchRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    MatBottomSheetModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatDialogModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatTabsModule,
    ToastrModule.forRoot(), NgxPaginationModule, NgMultiSelectDropDownModule,
    SidebarModule.forRoot(),
  ]
})
export class WebhookSearchModule { }
